import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {Actions} from '../../../../common/actions';
import {Modal, Button} from 'semantic-ui-react';

const {sendCampaignNotification} = Actions;

const NotificationModal = ({
  campaingNo,
  campaingName,
  detail,
  sscCode,
  status,
  disabled,
}) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const dispatch = useDispatch();

  const handleNotification = () => {
    const data = {campaingNo, campaingName, detail, sscCode, status};
    dispatch(sendCampaignNotification(data));
    setModalIsOpen(false);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const openModal = () => {
    setModalIsOpen(true);
  };

  return (
    <Modal
      size='tiny'
      onOpen={openModal}
      open={modalIsOpen}
      className='notification-modal'
      trigger={
        <Button disabled={disabled} color='black'>
          NOTIFICAR
        </Button>
      }
    >
      <Modal.Header>Enviar notificación</Modal.Header>
      <Modal.Content className='notification-content'>
        <p>¿Está seguro que desea enviar la notificación de la campaña</p>
        <p>{`${sscCode} - ${campaingName}?`}</p>
      </Modal.Content>

      <Modal.Actions>
        <Button onClick={closeModal}>Cerrar</Button>
        <Button positive onClick={handleNotification}>
          Notificar
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default NotificationModal;
